"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationContext = exports.useInvitation = void 0;
const snap_ui_1 = require("@teamsnap/snap-ui");
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const api_1 = require("core/api");
const React = __importStar(require("react"));
const react_router_1 = require("react-router");
const validation_signup_1 = require("utils/validation-signup");
const utils_1 = require("src/core/utils");
const useAmpli_1 = require("src/hooks/useAmpli");
const useExperiments_1 = require("src/hooks/useExperiments");
const useNavigation_1 = require("src/hooks/useNavigation");
const useRequest_1 = require("src/hooks/useRequest");
const defaultNewUser = {
    email: '',
    firstName: '',
    lastName: '',
    password: '',
    birthdate: '',
    receivesNewsletter: true,
    termsAndConditionsAccepted: false,
    phone: '',
    relationship: '',
    gender: null,
    isBirthdayPublic: false,
    rosterBirthdate: '',
};
const useInvitation = () => {
    const { navigate, getState } = (0, useNavigation_1.useNavigation)();
    const experiments = (0, useExperiments_1.useExperiments)();
    const ageGating = experiments[useExperiments_1.EXPERIMENT_IDS.AGE_GATING];
    const birthdateRequired = ageGating ? ageGating?.isEnabled && ageGating?.hasAccess : undefined;
    const { invitationCode } = (0, react_router_1.useParams)();
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams?.get('email')?.replace(' ', '+') || ''; // URLSearchParams converts + to space, so we need to convert it back
    const [newUser, setNewUser] = React.useState({
        ...defaultNewUser,
        email,
    });
    const [invitation, setInvitation] = React.useState(null);
    const [userIsRosterMember, setUserIsRosterMember] = React.useState();
    const [guardianSelected, setGuardianSelected] = React.useState();
    const [offers, setOffers] = React.useState();
    const [loadOffersError, setLoadOffersError] = React.useState();
    const [checkoutError, setCheckoutError] = React.useState();
    const [errors, setErrors] = React.useState({});
    const { error, isProcessing, makeRequest } = (0, useRequest_1.useRequest)();
    const loadOffers = async () => {
        try {
            setLoadOffersError(undefined);
            const teamId = invitation?.metadata?.teamId;
            if (!teamId) {
                return;
            }
            const { data } = await makeRequest(() => api_1.UserService.getOffers(teamId));
            const annualEntry = Object.entries(data?.prices ?? {}).find(([, price]) => price.frequency === 'year');
            const monthlyEntry = Object.entries(data?.prices ?? {}).find(([, price]) => price.frequency === 'month');
            if (!annualEntry || !monthlyEntry) {
                return;
            }
            const [, annualPrice] = annualEntry;
            const [, monthlyPrice] = monthlyEntry;
            const offers = { annual: annualPrice, monthly: monthlyPrice };
            setOffers(offers);
            return offers;
        }
        catch (error) {
            setLoadOffersError(error + '');
        }
    };
    const loadInvitation = async () => {
        if (!invitationCode) {
            return;
        }
        const { data } = await makeRequest(() => api_1.InvitationService.getInvitation(invitationCode));
        data && setInvitation(data);
        return data;
    };
    React.useEffect(() => {
        loadInvitation();
        const newUserState = getState('newUser');
        if (newUserState) {
            // rehydrate on page refresh
            setNewUser(newUserState);
        }
    }, []);
    const submitClaimInvite = () => {
        const er = (0, validation_signup_1.validateSignupFields)(newUser, [
            ...['email', 'password', 'termsAndConditionsAccepted'],
            ...(birthdateRequired ? ['birthdate'] : []),
        ]);
        if (Object.keys(er).length > 0) {
            setErrors(er);
            er?.termsViolated &&
                setNewUser({
                    ...defaultNewUser,
                    email: newUser.email,
                    // TODO remove this hack once snapi-ui component is updated
                    birthdate: '---', // temp hack clear birthdate
                }); // clear form on termsViolated
            return;
        }
        navigate.v1InviteRole(invitationCode ?? '', { newUser });
    };
    const submitRole = () => {
        const fieldsToValidate = ['firstName', 'lastName', 'relationship'];
        if (newUser.phone) {
            // only validate phone if it has a value
            fieldsToValidate.push('phone');
        }
        const er = (0, validation_signup_1.validateSignupFields)(newUser, fieldsToValidate);
        if (Object.keys(er).length > 0) {
            setErrors(er);
            return;
        }
        navigate.v1InviteRoster(invitationCode ?? '', { newUser });
    };
    const submitUser = async () => {
        let uciUserId = '';
        if (isProcessing) {
            return;
        }
        const fieldsToValidate = userIsRosterMember ? ['firstName', 'lastName'] : ['rosterBirthdate', 'gender'];
        if (newUser.phone && userIsRosterMember) {
            // only validate phone if it has a value
            fieldsToValidate.push('phone');
        }
        const er = (0, validation_signup_1.validateSignupFields)(newUser, fieldsToValidate);
        if (Object.keys(er).length > 0) {
            setErrors(er);
            return;
        }
        const userBody = {
            email: newUser.email,
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            password: newUser.password,
            birthdate: newUser.birthdate,
            receivesNewsletter: !!newUser.receivesNewsletter,
            termsAndConditionsAccepted: !!newUser.termsAndConditionsAccepted,
        };
        if (!newUser.id) {
            const { error: userError } = await makeRequest(() => api_1.NewUserService.createUser(userBody)); // Sets sso cookie
            if (userError) {
                if (userError?.title?.toLowerCase().includes('email')) {
                    setErrors((prev) => ({ ...prev, email: userError.detail }));
                    navigate.v1InviteClaim(invitationCode ?? '', { newUser });
                }
                if (userError?.title?.toLowerCase().includes('password')) {
                    setErrors((prev) => ({ ...prev, password: userError.detail }));
                    const updatedUser = { ...newUser, password: '' };
                    setNewUser(updatedUser);
                    setErrors((prev) => ({ ...prev, password: userError.detail }));
                    navigate.v1InviteClaim(invitationCode ?? '', { newUser: updatedUser });
                }
                return;
            }
            // get the newly created user id to prevent trying to re-create the user
            const { data: user } = await makeRequest(() => api_1.UserService.showUser());
            uciUserId = user?.uciUuid ?? '';
            user && (0, useAmpli_1.setUserId)(user.uciUuid ?? '');
            user && (0, useAmpli_1.userIdentify)(user.uciUuid ?? '', { email: user.email });
            user && setNewUser({ ...newUser, id: user.id });
        }
        const phoneNumber = newUser.phone ? (0, snap_ui_1.phoneNumberToE164)(newUser.phone) : undefined;
        const acceptBody = {
            rosterInfo: {
                firstName: userIsRosterMember ? newUser.firstName : undefined,
                lastName: userIsRosterMember ? newUser.lastName : undefined,
                phoneNumber,
                gender: newUser.gender || undefined,
                birthday: userIsRosterMember && newUser.isBirthdayPublic ? newUser.birthdate : newUser.rosterBirthdate,
            },
            contactInfo: guardianSelected
                ? {
                    relationship: newUser.relationship ?? '',
                    firstName: newUser.firstName,
                    lastName: newUser.lastName,
                    phoneNumber,
                }
                : undefined,
        };
        const { error } = await makeRequest(() => api_1.InvitationService.acceptInvitation(invitationCode ?? '', acceptBody));
        if (error) {
            if (error?.title?.toLowerCase().includes('phone')) {
                setErrors((prev) => ({ ...prev, phone: error.detail }));
                navigate.v1InviteRole(invitationCode ?? '', { newUser });
            }
            return;
        }
        const hasAccessToInviteOffers = experiments?.inviteOffers?.hasAccess;
        const offersLoaded = (await loadOffers()) || undefined;
        uciUserId &&
            (0, useAmpli_1.userIdentify)(uciUserId, {
                onboarding_invite_tsplus_rollout_group: hasAccessToInviteOffers,
                onboarding_invite_tsplus_content_available: offersLoaded !== undefined,
                selected_team_sport: invitation?.metadata?.sportName,
            });
        if (hasAccessToInviteOffers && offersLoaded) {
            return navigate.v1InviteTsPlusOffer(invitationCode ?? '', { newUser });
        }
        navigate.continueInviteClassic(invitationCode ?? '');
    };
    const onLogin = async () => {
        const { data: user } = await makeRequest(() => api_1.UserService.showUser());
        user && (0, useAmpli_1.setUserId)(user.uciUuid ?? '');
        user && (0, useAmpli_1.userIdentify)(user.uciUuid ?? '', { email: user.email });
        const updatedUser = {
            ...newUser,
            id: user?.id,
            email: user?.email,
            firstName: user?.firstName,
            lastName: user?.lastName,
            birthdate: user?.birthdate || '',
        };
        // @ts-ignore
        user && setNewUser(updatedUser);
        navigate.v1InviteRole(invitationCode ?? '', { newUser: updatedUser });
    };
    const continueInviteClassic = () => {
        navigate.continueInviteClassic(invitationCode ?? '');
    };
    const checkout = async (priceId) => {
        try {
            const { data } = await makeRequest(() => api_1.UserService.createUserSubscriptionCheckout({
                priceId,
                checkoutContext: {
                    type: api_1.UserSubscriptionCheckoutContextType_Invitation.INVITATION,
                    invitationCode: invitationCode ?? '',
                },
            }));
            if (data?.checkoutUrl) {
                (0, utils_1.redirectTo)(data.checkoutUrl);
            }
        }
        catch (error) {
            setCheckoutError(error + '');
        }
    };
    return {
        newUser,
        setUser: (key, value) => {
            const er = { ...errors };
            delete er[key];
            setErrors(er);
            setNewUser({ ...newUser, [key]: value });
        },
        submitClaimInvite,
        submitRole,
        submitUser,
        teamName: invitation?.metadata?.teamName,
        rosterFirstName: invitation?.metadata?.rosterFirstName || 'the player',
        userIsRosterMember,
        setUserIsRosterMember,
        guardianSelected,
        setGuardianSelected,
        errors,
        isProcessing,
        invitationLoading: invitation === null && !error,
        invitationLoadError: (invitation === null && !!error) || !invitationCode,
        birthdateRequired,
        onLogin,
        continueInviteClassic,
        teamSport: invitation?.metadata?.sportName,
        offers,
        // @ts-ignore
        loadOffers,
        loadOffersError: loadOffersError ?? '',
        checkout,
        checkoutError: checkoutError ?? '',
        invitationCode: invitationCode ?? '',
    };
};
exports.useInvitation = useInvitation;
exports.InvitationContext = React.createContext({});
